import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { getWhatsAppUrl } from '../../utils/whatsapp';

// Krypton Serviced Residences Assets
const KRYPTON_IMAGES = [
  { id: 1, src: "https://customer-assets-rejwkqb3.emergentagent.net/job_0015c62d-f7c2-4949-8e6d-391effbaad9b/artifacts/200833825e7412af_Krypton_01_aerial-golden-hour.webp", alt: "Krypton aerial view at golden hour" },
  { id: 2, src: "https://customer-assets-rejwkqb3.emergentagent.net/job_0015c62d-f7c2-4949-8e6d-391effbaad9b/artifacts/99fb047498783688_Krypton_02_boulevard-daytime.webp", alt: "Krypton boulevard daytime view" },
  { id: 3, src: "https://customer-assets-rejwkqb3.emergentagent.net/job_0015c62d-f7c2-4949-8e6d-391effbaad9b/artifacts/a8a8310c04ee3f1a_Krypton_03_promenade-family.webp", alt: "Krypton promenade with family" },
  { id: 4, src: "https://customer-assets-rejwkqb3.emergentagent.net/job_0015c62d-f7c2-4949-8e6d-391effbaad9b/artifacts/e948d7f6aabbddb0_Krypton_04_plaza-fountain.webp", alt: "Krypton central plaza with fountain" },
  { id: 5, src: "https://customer-assets-rejwkqb3.emergentagent.net/job_0015c62d-f7c2-4949-8e6d-391effbaad9b/artifacts/663faa225753034b_Krypton_05_plaza-shopfronts.webp", alt: "Krypton plaza shopfronts" }
];

const LaunchAnnouncementsSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="bg-gradient-to-b from-slate-900 to-slate-800 py-16 lg:py-20 relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium tracking-[0.25em] text-sky-400 uppercase mb-4">
            New Release
          </span>
          <h2 className="text-4xl lg:text-5xl font-light text-white mb-3">
            Krypton Serviced Residences
          </h2>
          <p className="text-xl text-slate-300">
            Live • Shop • Dine • Belong
          </p>
        </div>
        
        {/* Image Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-10">
          {KRYPTON_IMAGES.map((image) => (
            <div 
              key={image.id}
              className="aspect-[4/3] overflow-hidden rounded-sm cursor-pointer group"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
            </div>
          ))}
        </div>
        
        {/* Price Line */}
        <p className="text-center text-lg text-slate-300 mb-8">
          Serviced residences starting from <span className="text-white font-semibold">8 Million EGP</span>
        </p>
        
        {/* CTA Button */}
        <div className="text-center">
          <a
            href={getWhatsAppUrl("Hi, I'm interested in Krypton Serviced Residences at NEWKAIRO. Please share more details.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 text-white text-sm font-medium tracking-wide rounded-sm hover:bg-green-600 transition-all duration-300 shadow-lg"
          >
            <MessageCircle size={18} />
            More Details
          </a>
        </div>
      </div>
      
      {/* Lightbox for selected image */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white/80 hover:text-white"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[90vh] object-contain"
          />
        </div>
      )}
    </section>
  );
};

export default LaunchAnnouncementsSection;
